module.exports = __webpack_public_path__ + "img/ht.13a00172.svg";